var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"error"}},[(this.field.$dirty && !this.field.required)?_c('div',{staticClass:"error message"},[_vm._v("\n\t\tэто обязательное поле\n\t")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }